<template>
  <sec-page>
    <sec-hero :eyebrow="a.hero.eyebrow" :title="a.hero.title" :lede="a.hero.lede">
      <sec-actions :actions="a.hero.actions" />
    </sec-hero>

    <sec-section>
      <sec-section-heading :eyebrow="a.whatYouGet.eyebrow" :title="a.whatYouGet.title" />
      <sec-plain-list :items="a.whatYouGet.items" />
    </sec-section>

    <sec-section>
      <sec-section-heading :eyebrow="a.theWeek.eyebrow" :title="a.theWeek.title" />
      <sec-day-steps :days="a.theWeek.days" />
      <p class="m500 sec-body" data-reveal><sec-rich :value="a.theWeek.needs" /></p>
      <p class="m500 sec-body" data-reveal><sec-rich :value="a.theWeek.outOfScope" /></p>
    </sec-section>
  </sec-page>
</template>

<script setup>
// Claude Code Security and Adoption Assessment: the one week front-door engagement.
import SecPage from '@/components/security/ui/SecPage.vue';
import SecHero from '@/components/security/ui/SecHero.vue';
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecActions from '@/components/security/ui/SecActions.vue';
import SecPlainList from '@/components/security/ui/SecPlainList.vue';
import SecDaySteps from '@/components/security/ui/SecDaySteps.vue';
import SecRich from '@/components/security/ui/SecRich.vue';
import { ASSESSMENT } from '@/content/security/assessment';

const a = ASSESSMENT;
</script>
